<template>
    <v-container fluid>
        <v-btn
            :loading="dayBatchesWithInfo === null"
            @click="loadDayBatchesNonValidated"
            bottom
            class="mb-10"
            color="secondary darken-1"
            fab
            fixed
            right
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-row
            align="center"
            no-gutters
        >
            <v-col
                cols="12"
                justify="center"
                sm="8"
            >
                <v-subheader>
                    <h2>Day Batches Submission ({{ totalMatches }})</h2>
                </v-subheader>
            </v-col>
            <!--<v-col
                cols="12"
                lg="4"
                sm="6"
            >
                <v-text-field
                    @click:clear="setSearch('')"
                    @input="setSearch"
                    clearable
                    label="Search"
                    prepend-icon="mdi-magnify"
                    single-line
                />
            </v-col>-->
            <v-col
                class="text-right"
                cols="12"
                sm="4"
            >
                <v-btn
                    @click="showMultiSearch = !showMultiSearch"
                    color="secondary darken-1"
                    icon
                >
                    <v-icon v-if="anyMultiSearchInput">mdi-card-search</v-icon>
                    <v-icon v-else>mdi-card-search-outline</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-container class="pb-10">
            <v-row
                justify="center"
                v-if="dayBatchesWithInfo === null"
            >
                <v-col
                    :key="i"
                    cols="12"
                    v-for="i in 6"
                >
                    <v-skeleton-loader
                        elevation="4"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row
                justify="center"
                v-else
            >
                <v-col
                    :key="dayBatchWithInfo.id"
                    cols="12"
                    v-for="dayBatchWithInfo in dayBatchesWithInfo"
                >
                    <v-card
                        class="incident-card fill-height"
                        elevation="4"
                        style="overflow: hidden"
                        @click="loadDayBatchForm(dayBatchWithInfo)"
                    >
                        <v-card-title
                            
                        >
                            #{{
                            dayBatchWithInfo.dayBatchNumber
                            }}
                        </v-card-title>
                        <!--
                        <v-card-subtitle
                            >Provider:
                            {{
                                getProviderName(dayBatchWithInfo.providerId)
                            }}
                            <br />
                            Incident: #{{ dayBatchWithInfo.incidentId }}
                            <br />
                            Funding Type:
                            {{
                                getFundingTypeName(
                                    dayBatchWithInfo.fundingType
                                )
                            }}
                            <br />
                            Number of Accounts:
                            {{ dayBatchWithInfo.info.accountsCount }}
                            <br />
                            Face Value: R{{
                                dayBatchWithInfo.info.faceValue.toFixed(2)
                            }}
                            <br />
                            Purchase Value: R{{
                                dayBatchWithInfo.info.purchaseValue.toFixed(2)
                            }}
                        </v-card-subtitle>
                        -->

                        <!--
                        <v-card-subtitle class="py-0 my-0"
                            ><strong>Accounts</strong></v-card-subtitle
                        >
                        <v-card
                            rounded="0"
                            :key="indexA"
                            v-for="(account, indexA) in dayBatchWithInfo
                                .accounts"
                            class="patient-panel"
                            @click.stop="
                                $router.push({
                                    name: 'Accounts',
                                    params: { accountId: account.id },
                                })
                            "
                        >
                            <v-card-text class="my-0 py-0">
                                <v-row justify="start">
                                    <v-col cols="12">
                                        <div style="display: inline-block">
                                            #{{ account.id }}
                                        </div>
                                        <v-chip
                                            class="ma-1"
                                            color="secondary"
                                            dark
                                            small
                                            >GRV Number:
                                            {{ account.grvNumber }}
                                        </v-chip>
                                        <v-chip
                                            class="ma-1"
                                            color="secondary"
                                            dark
                                            small
                                            >Face Value:
                                            {{
                                                account.faceValue.toFixed(2)
                                            }}</v-chip
                                        >
                                        <v-chip
                                            class="ma-1"
                                            color="secondary"
                                            dark
                                            small
                                            >Purchase Value:
                                            {{
                                                (
                                                    (account.faceValue / 100) *
                                                    (100 -
                                                        (account.fundingType ==
                                                        1
                                                            ? account.providerPrefundFeePercentage
                                                            : account.providerAdminFeePercentage))
                                                ).toFixed(2)
                                            }}</v-chip
                                        >
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                        -->
                        <div>
                            <v-card-text class="center-content pa-2">
                                <v-row justify="space-around">
                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        <v-card class="pa-1 ma-1 fill-height">
                                            Claims
                                            <br />Printed &amp; Verified
                                            <br />
                                            <h3>{{dayBatchWithInfo.claimsPrintedAndVerified + "/" + dayBatchWithInfo.claimsCount }}</h3>
                                        </v-card>
                                    </v-col>
                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        <v-card class="pa-1 ma-1 fill-height">
                                            Cover Page
                                            <br />Printed &amp; Verified
                                            <br />
                                            <h3>
                                                <v-icon
                                                    color="success"
                                                    v-if="
                                                        dayBatchWithInfo
                                                            .coverPagePrintedAndVerified
                                                    "
                                                >mdi-check</v-icon>
                                                <v-icon
                                                    color="error"
                                                    v-else
                                                >mdi-close</v-icon>
                                            </h3>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <!--EDIT FORM SECTION-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-->
        <v-dialog
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            v-model="dayBatchFormVisible"
        >
            <v-sheet
                class="base-background"
                min-height="100%"
            >
                <v-toolbar
                    color="secondary darken-1"
                    dark
                >
                    <v-btn
                        @click="closeDayBatchForm"
                        dark
                        icon
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Day Batch Details</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-container>
                    <v-row
                        align="center"
                        justify="center"
                        v-if="true"
                    >
                        <DayBatchSubmissionForm
                            :day-batch-in="dayBatchFormId"
                            :day-batch-number="dayBatchFormDayBatchNumber"
                            :key="dayBatchFormId"
                            @close="closeDayBatchForm"
                            @deleted="deleteDayBatch"
                            @saved="updateDayBatch"
                        />
                    </v-row>
                </v-container>
            </v-sheet>
        </v-dialog>

        <!--NEW FORM SECTION-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-->
        <v-dialog
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            v-model="dayBatchCreateFormVisible"
        >
            <v-sheet
                class="base-background"
                min-height="100%"
            >
                <v-toolbar
                    color="secondary darken-1"
                    dark
                >
                    <v-btn
                        @click="closeDayBatchCreateForm"
                        dark
                        icon
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Day Batch Details</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-container>
                    <v-row
                        align="center"
                        justify="center"
                    >
                        <DayBatchCreateForm
                            :key="dayBatchCreateFormKey"
                            @close="closeDayBatchCreateForm"
                            @saved="updateDayBatch"
                        />
                    </v-row>
                </v-container>
            </v-sheet>
        </v-dialog>

        <!--FILTER SECTION-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-->
        <v-dialog
            transition="scroll-x-reverse-transition"
            v-model="showFilters"
            width="350px"
        >
            <v-card>
                <v-card-title>DayBatch Filtering</v-card-title>
                <v-card-text>
                    <v-divider class="mt-3 mb-8"></v-divider>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        @click="resetFilters"
                        class="text-none"
                        color="secondary darken-1"
                        text
                    >Reset</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="showFilters = !showFilters"
                        class="text-none"
                        color="secondary darken-1"
                        text
                    >Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--MultiSeardch SECTION-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-->
        <v-dialog
            v-model="showMultiSearch"
            width="350px"
        >
            <multi-search-input-form
                :fields="multiSearchFields"
                @close="showMultiSearch = false"
                @reset="multiSearch"
                @search="multiSearch"
            />
        </v-dialog>
        <!--PAGINATION SECTION-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-->
        <v-pagination
            :length="pagesCount"
            @input="paginationDebounce(500)"
            class="pagination-bar base-background"
            total-visible="7"
            v-model="pageNo"
            v-show="pagesCount > 1"
        ></v-pagination>
    </v-container>
</template>

<script>
import DayBatchSubmissionForm from "../components/forms/DayBatchSubmissionForm";
import DayBatchCreateForm from "../components/forms/DayBatchCreateForm";
import MultiSearchInputForm from "../components/forms/MultiSearchInputForm";
import uuid4 from "../helpers/uuid4";

export default {
    name: "DayBatches",
    props: [
        "providerId",
        "areaId",
        "agedDaysMin",
        "agedDaysMax",
        "allPrinted",
        "allPod",
        "allLink"
    ],
    data: function() {
        return {
            //main data
            dayBatchesWithInfo: null,
            fundingTypes: [],
            identityTypes: [],
            //pagination
            pageNo: 1,
            pageSize: 6,
            pagesCount: 0,
            searchString: "",
            orderBy: "",
            sortOrder: 0,
            paginationTimeout: null,
            requestId: uuid4(),
            totalMatches: null,

            //new dayBatches list
            dayBatchCreateFormVisible: false,
            dayBatchCreateFormKey: null,

            //form data
            dayBatchFormVisible: false,
            dayBatchFormId: null,
            dayBatchFormDayBatchNumber: null,

            providers: [],

            //filters
            filterProviderId: this.providerId > 0 ? this.providerId : null,
            filterAreaId: this.areaId > 0 ? this.areaId : null,
            showFilters: false,
            filterDebounceTime: 500,
            //

            showMultiSearch: false,
            multiSearchFields: [
                { display: "DayBatchNumber #", property: "dayBatchNumber" },
                { display: "Claim #", property: "claimId" },
                { display: "Link Number", property: "linkNumber" },
                { display: "Provider Name", property: "providerName" },
                { display: "Account #", property: "accountId" },
                { display: "Patient Name", property: "patientName" },
                { display: "Patient Surname", property: "patientSurname" },
                {
                    display: "Patient Identity Number",
                    property: "patientIdentityNumber"
                },
                { display: "Grv Number", property: "grvNumber" },
                { display: "Invoice Number", property: "invoiceNumber" }
            ],
            multiSearchValues: []
        };
    },
    created: async function() {
        this.providers = await this.$store.dispatch("providers/getlist");
        this.fundingTypes = await this.$store.dispatch(
            "accounts/getFundingTypes"
        );
        this.identityTypes = await this.$store.dispatch("identities/getTypes");
        this.getDayBatches();
    },
    mounted: function() {
        this.multiSearchValues = this.multiSearchFields.map(function(x) {
            return { display: x.display, property: x.property, value: x.value };
        });
    },
    components: {
        DayBatchSubmissionForm,
        DayBatchCreateForm,
        MultiSearchInputForm
        //
    },
    computed: {
        anyMultiSearchInput: function() {
            return this.multiSearchValues.some(
                x => x.value != "" && x.value != null
            );
        }
        //
    },
    methods: {
        multiSearch(values) {
            this.multiSearchValues = values;
            this.searchString = "";
            this.pageNo = 1;
            this.pagesCount = 0;
            this.paginationDebounce(0);
        },
        async getDayBatches() {
            var requestId = (this.requestId = uuid4());
            var urlParameters = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                searchString: this.searchString,
                orderBy: this.orderBy,
                sortOrder: this.sortOrder,
                isSubmitted: false,
                providerId: this.filterProviderId
                    ? this.filterProviderId
                    : null,
                areaId: this.filterAreaId ? this.filterAreaId : null,
                //NEW ONES TO BE ADDED TO FILTER GUI AND FILTER RESET
                agedDaysMin: this.agedDaysMin ? this.agedDaysMin : null,
                agedDaysMax: this.agedDaysMax ? this.agedDaysMax : null,
                allPrinted:
                    this.allPrinted !== undefined ? this.allPrinted : null,
                allPod: this.allPod !== undefined ? this.allPod : null,
                allLink: this.allLink !== undefined ? this.allLink : null
            };

            this.multiSearchValues
                .filter(x => x.value != "" && x.value != null)
                .forEach(x => (urlParameters[x.property] = x.value));

            var dayBatchesResponse = await this.$store.dispatch(
                "dayBatches/getpostsubmissionreducedview",
                //"dayBatches/get",
                {
                    id: null,
                    urlParameters,
                    requestId: requestId
                }
            );

            if (this.requestId == dayBatchesResponse.requestId) {
                //dayBatchesResponse.data.page.forEach(x =>this.dayBatchApplyDisciplineName(x.entity));
                this.dayBatchesWithInfo = dayBatchesResponse.data.page;
                this.totalMatches = dayBatchesResponse.data.total;
                this.pagesCount = Math.ceil(
                    dayBatchesResponse.data.total / this.pageSize
                );
            }
        },
        paginationDebounce(debounceTime) {
            if (this.dayBatchesWithInfo !== null)
                this.dayBatchesWithInfo = null;
            clearTimeout(this.paginationTimeout);
            this.paginationTimeout = setTimeout(
                this.getDayBatches,
                debounceTime
            );
        },
        setSearch(value) {
            this.searchString = value;
            this.pageNo = 1;
            this.pagesCount = 0;
            this.paginationDebounce(1000);
        },
        resetFilters() {
            this.filterProviderId = null;
            this.filterPatient = null;
            this.paginationDebounce(0);
        },
        /*
        dayBatchApplyDisciplineName(dayBatch) {
            dayBatch.disciplineName = this.dayBatchDisciplines.find(
                y => y.id == dayBatch.disciplineId
            ).name;
        },*/
        loadDayBatchForm(dayBatch) {
            this.dayBatchFormId = dayBatch.id;
            this.dayBatchFormDayBatchNumber = dayBatch.dayBatchNumber;
            this.dayBatchFormVisible = true;
        },
        closeDayBatchForm() {
            this.dayBatchFormVisible = false;
            this.dayBatchFormId = null;
            this.dayBatchFormDayBatchNumber = null;
            this.paginationDebounce(0);
        },
        updateDayBatch() {
            this.paginationDebounce(0);
        },
        deleteDayBatch() {
            this.paginationDebounce(0);
        },
        loadDayBatchesNonValidated() {
            this.dayBatchCreateFormVisible = true;
            this.dayBatchCreateFormKey = 0;
        },
        closeDayBatchCreateForm() {
            this.dayBatchCreateFormVisible = false;
            this.dayBatchCreateFormKey = null;
        }
    }
};
</script>

<style lang="stylus" scoped>
.incident-card {
    /* background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1)) */
    .center-content {
        background-color: rgba(127, 127, 127, 0.15);
    }
}

.theme--dark {
    .patient-panel {
        .v-card {
            background-color: rgba(127, 127, 127, 0.1);
        }
    }
}

.pagination-bar {
    // position: fixed;
    bottom: 0;
    margin: auto;
    left: 0;
    right: 0;
    padding-bottom: 0.1rem;
    padding-top: 0.1rem;
    /*
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border:1px solid rgba(127, 127, 127, 0.2)
    */
}

.theme--light {
    .base-background {
        background: #FFFFFF;
    }
}

.theme--dark {
    .base-background {
        background: #121212;
    }
}
</style>
